import { StockItemDetails } from '../stock/stock-item-details';

export interface PurchaseOrderLineRelocate {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  balance: number;

  stockItems: StockItemDetails[];
}
